import { ETipoQuestPergunta, IQuestPergunta } from "@deltasge/marauders-map";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Radio,
  RadioGroup,
  Tooltip,
} from "@mui/material";
import React, { FC } from "react";

export const AlternativasComponent: FC<{
  qtdeEtapas: number;
  nomeEtapa: string;
  etapa: number;
  etapaAtual: number;
  value: string;
  pergunta: IQuestPergunta;
  setValue: (value: string) => void;
}> = ({
  etapa,
  nomeEtapa,
  qtdeEtapas,
  etapaAtual,
  value,
  pergunta,
  setValue,
}) => {
  return (
    <FormControl size="small">
      {qtdeEtapas > 1 && (
        <FormLabel>{`${
          qtdeEtapas == 1 ? etapaAtual : etapa + 1
        }º ${nomeEtapa}`}</FormLabel>
      )}
      {pergunta.tipo == ETipoQuestPergunta.Objetiva && (
        <RadioGroup
          row
          value={value}
          onChange={({ target: { value } }) => setValue(value)}
          onClick={(e) => {
            const { value: currValue, checked } = e.target as EventTarget &
              HTMLInputElement;
            if (checked && value == currValue) {
              setValue("");
            }
          }}
        >
          {(pergunta.ordens ?? []).map((ordem) => (
            <Tooltip
              title={ordem.alternativa?.texto}
              key={`atitude-${pergunta.id}-${ordem.id}`}
            >
              <FormControlLabel
                value={ordem.id}
                control={<Radio />}
                label={ordem.alternativa?.texto}
              />
            </Tooltip>
          ))}
        </RadioGroup>
      )}
      {pergunta.tipo == ETipoQuestPergunta["Multipla Escolha"] && (
        <FormGroup>
          {(pergunta.ordens ?? []).map((ordem) => (
            <Tooltip
              title={ordem.alternativa?.texto}
              key={`atitude-${pergunta.id}-${ordem.id}`}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={value.indexOf(ordem.id?.toString() || "") >= 0}
                    onChange={({ target: { checked } }) => {
                      if (checked && value == "") {
                        setValue(ordem.id?.toString() || "");
                      } else if (
                        checked &&
                        value.indexOf(ordem.id?.toString() || "") < 0
                      ) {
                        setValue(`${value},${ordem.id}`);
                      } else if (!checked) {
                        setValue(
                          value
                            .split(",")
                            .filter((f) => f != ordem.id?.toString() || "")
                            .join()
                        );
                      }
                    }}
                  />
                }
                label={ordem.alternativa?.texto}
              />
            </Tooltip>
          ))}
        </FormGroup>
      )}
    </FormControl>
  );
};
